// extracted by mini-css-extract-plugin
export default {"common":"Heading_common__x0Ho3","base__dark":"Heading_base__dark__Z5wzp","primary__dark":"Heading_primary__dark__GXF4q","base__light":"Heading_base__light__BC61F"};